import React, { useEffect, useState } from 'react'
import {
  Modal,
  message,
  Form,
} from "antd";
import Select from "react-select";
import axiosInstance from '../../../utils/axiosInstance';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../utils/themeToggle/theme';

const AssignOtherUser = ({ isAssignModal, handleCancel, assingSenderId, onSuccessAssign, role, type }) => {
  const [form] = Form.useForm();
  const [assignee, setAssignee] = useState([]);
  const [company, setCompany] = useState([]);
  const comp_id = useSelector((state) => state.auth.userInfo.company_id);
  const conpanyId = localStorage.getItem("companyId") || comp_id;
  const { reactSelectTheme } = useTheme();

  useEffect(() => {
    if (type === "professional") {
      fetchCompanyDetails();
    } else {
      fetchAssignee(role);
    }
    form.resetFields();
  }, [role, type]);

  const handleOk = () => {
    form.submit();
  };

  const fetchAssignee = async (role) => {
    try {
      const response = await axiosInstance.post(`/get-users-by-admin/`, { role, company_id: conpanyId })
      setAssignee(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCompanyDetails = async () => {
    try {
      const companyRes = await axiosInstance.post("/dashboard/all_companes_agreement_count/");
      setCompany(companyRes.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  const onFinishAssignee = () => {
    form.validateFields();
    const values = form.getFieldsValue();

    if (type === "professional") {
      const payload = {
        user_id: assingSenderId,   // jis professional ko assign karna hai
        company_id: values.user_id.value, // dropdown se selected company_id
      };
      axiosInstance.post(`/company/assign-company/`, payload)
        .then(() => {
          message.success("Company assigned successfully.");
          form.resetFields();
          onSuccessAssign();
        })
        .catch((error) => {
          console.error("API Error:", error);
          message.error(error?.response?.data?.error || "Failed to assign company.");
        });
    } else {
      const payload = {
        sender_id: assingSenderId,
        assign_id: values.user_id.value,
      };
      axiosInstance.put(`/assign-agreements/`, payload)
        .then(() => {
          message.success("Agreements assigned successfully.");
          form.resetFields();
          onSuccessAssign();
        })
        .catch((error) => {
          console.error("API Error:", error);
          message.error(error?.response?.data?.error || "Failed to assign agreements.");
        });
    }
  };

  return (
    <Modal
      title={type === "professional" ? "Assign Company" : "Assign User"}
      open={isAssignModal}
      onOk={handleOk}
      onCancel={handleCancel}
      style={{ fontSize: "24px", padding: "40px" }}
      okText="Save"
      okButtonProps={{
        style: {
          backgroundColor: "#4E36A3",
          color: "white",
          height: "40px",
          width: "100px",
        },
      }}
      cancelButtonProps={{
        style: {
          color: "#4E36A3",
          height: "40px",
          width: "100px",
        },
      }}
    >
      <Form form={form} onFinish={onFinishAssignee}>
        <Form.Item
          name="user_id"
          label={type === "professional" ? "Select Company" : "Select User"}
          style={{ marginBottom: 20 }}
          rules={[
            { required: true, message: type === "professional" ? "Please select a company" : "Please select a user" },
          ]}
        >
          <Select
            options={
              type === "professional"
                && company.length > 0 ? company.map((comp) => ({
                  value: comp.company_id,
                  label: comp.company_name,
                }))
                : assignee
                  ? Object.values(assignee).filter((item) => item.id !== assingSenderId).map((user) => ({
                    value: user.id,
                    label: user.first_name,
                  }))
                  : []
            }
            styles={reactSelectTheme}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
};

export default AssignOtherUser;
